import React, {
    useState, useContext, createContext
} from 'react';

import PropTypes from 'prop-types';

const LeftBarContext = createContext();

function LeftBarProvider({ children }) {
    const [leftBarOpened, setLeftBarOpened] = useState(window.innerWidth > 688);

    return (
        <LeftBarContext.Provider value={{ leftBarOpened, setLeftBarOpened }}>
            {children}
        </LeftBarContext.Provider>
    );
}

function useLeftBar() {
    const context = useContext(LeftBarContext);

    if (!context) {
        throw new Error('useFilterBar should be used within a LeftBarProvider');
    }

    return context;
}

LeftBarProvider.defaultProps = {
    children: {}
};

LeftBarProvider.propTypes = {
    children: PropTypes.object
};

export { LeftBarProvider, useLeftBar };
